// extracted by mini-css-extract-plugin
module.exports = {"artist":"styles_artist__2ObIM","icon":"styles_icon__2jZ75","text":"styles_text__2Uvfd"};